import { FolderContent } from '@/api/generatedApi';
import { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface ContentDragContextValue {
  currentFolderId: string | undefined;
  draggedContents: FolderContent[];
  setDraggedContents: (contents: FolderContent[]) => void;
  dropTargetFolderId: string | undefined;
  setDropTargetFolderId: (folderId: string | undefined) => void;
}

const ContentDragContext = createContext<ContentDragContextValue | undefined>(undefined);

export const ContentDragProvider = ({
  children,
  currentFolderId,
}: {
  children: ReactNode;
  currentFolderId: string | undefined;
}) => {
  const [draggedContents, setDraggedContents] = useState<FolderContent[]>([]);
  const [dropTargetFolderId, setDropTargetFolderId] = useState<string | undefined>();

  const value = useMemo(
    () => ({
      currentFolderId,
      draggedContents,
      setDraggedContents,
      dropTargetFolderId,
      setDropTargetFolderId,
    }),
    [currentFolderId, draggedContents, dropTargetFolderId]
  );

  return <ContentDragContext.Provider value={value}>{children}</ContentDragContext.Provider>;
};

export const useContentDrag = () => {
  const context = useContext(ContentDragContext);
  if (!context) {
    throw new Error('useContentDrag must be used within a ContentDragProvider');
  }
  return context;
};

export const useContentDragOptional = () => {
  return useContext(ContentDragContext);
};
